import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all () {
      return api.get(`establishment/all`)
    },

    update (request) {
      return api.post('establishment/update', request)
    }
  }
} else {
  module = {
    _all: [],

    all () {
      return delay(1500)({ data: { err: 'err' } })
    },

    update (r) {
      return delay(1500)({ data: { err: 'err' } })
    }
  }
}

export default module
